__turbopack_context__.v({
  "ButtonNova": "BI4GQq_ButtonNova",
  "CTA-20-Dia-Normal": "BI4GQq_CTA-20-Dia-Normal",
  "accordionBody": "BI4GQq_accordionBody",
  "accordionBox": "BI4GQq_accordionBox",
  "accordionBoxScalpCare": "BI4GQq_accordionBoxScalpCare",
  "accordionButton": "BI4GQq_accordionButton",
  "accordionButtonMen": "BI4GQq_accordionButtonMen",
  "active": "BI4GQq_active",
  "closeSubMenu": "BI4GQq_closeSubMenu",
  "fixedBottomNav": "BI4GQq_fixedBottomNav",
  "fixedBottomNavProducts": "BI4GQq_fixedBottomNavProducts",
  "menuButton": "BI4GQq_menuButton",
  "menuButtonMen": "BI4GQq_menuButtonMen",
  "menuIsOpen": "BI4GQq_menuIsOpen",
  "menuWrapper": "BI4GQq_menuWrapper",
  "mobileNavigation": "BI4GQq_mobileNavigation",
  "navIsOpen": "BI4GQq_navIsOpen",
  "openNav": "BI4GQq_openNav",
  "openSubMenu": "BI4GQq_openSubMenu",
  "products": "BI4GQq_products",
  "productsSection": "BI4GQq_productsSection",
  "subItemLink": "BI4GQq_subItemLink",
  "subItemLinkServices": "BI4GQq_subItemLinkServices",
  "textLink": "BI4GQq_textLink",
});
